import { Component, OnInit } from '@angular/core';
import { FILE_BLOB_TYPE, FILE_EXTENSION_TYPE, PRODUCT_SPEC_DATA } from './../app.constants'
import { UserRepositoryService } from '../services/user-repository.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { User } from '../shared/models/user.model';
import { DataSourceService } from '../services/data-source.service';
import * as FileSaver from 'file-saver';
import { event } from 'jquery';
import { environment } from 'src/environments/environment';
import { DownloadQRImage } from '../shared/models/branding-qr.model';

export enum DownloadType {
  None = '',
  StaticQRImages = 'Shop.Solarturbines.com_Home_QR_Images',
  CTAShopPartsWhite = 'CTA_Shop_For_Parts_White',
  CTAShopPartsBlack = 'CTA_Shop_For_Parts_Black',
  SolarLogos = 'Solor_Wordmark_Logo'
}
@Component({
  selector: 'app-qr-branding',
  templateUrl: './qr-branding.component.html',
  styleUrls: ['./qr-branding.component.scss']
})
export class QrBrandingComponent implements OnInit {
  product_spec_Data = PRODUCT_SPEC_DATA;
  private unsubscribe: Subject<void> = new Subject<void>();
  private user: User;
  isLoadingData: boolean;
  showMaxLimitError: boolean = false;
  maxChars: number = 30;
  searchQuery: string = '';
  isGeneratedQREnabled: boolean = false;
  isDisableGenQR: boolean = true;
  showPartNumberError: boolean = false;
  generateQRLink: string = '';
  generateStaticLink: string;
  envUrlPrefix: string;
  staticQREnvUrl: string;
  
  public DownloadType = DownloadType;
  partNumber: string;
  lastQRResponse: string = '';
  downloadqrResponse: DownloadQRImage;

  constructor(private userRepositoryService: UserRepositoryService,
    private dataSourceService: DataSourceService
  ) {
    this.envUrlPrefix = environment.QRApiUrl;
  }

  ngOnInit(): void {
    this.userRepositoryService.getMe();

    this.userRepositoryService.loggedUserData$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((user) => {
        this.user = user;
      });
    this.staticQREnvUrl = environment.QRApiUrl;
    this.staticQREnvUrl = `${this.envUrlPrefix}/static`;
  }


  onClickGenerateDownloadLink(path?: string): void {
    const staticPath = path;
    const filePath = `${staticPath}.zip`;
    this.generateStaticLink = filePath;

    switch (path) {
      case DownloadType.StaticQRImages:
        this.onClickDownloadFiles("",filePath);
        break;
      case DownloadType.CTAShopPartsWhite:
        this.onClickDownloadFiles("",filePath);
        break;
      case DownloadType.CTAShopPartsBlack:
        this.onClickDownloadFiles("",filePath);
        break;
      case DownloadType.SolarLogos:
        this.onClickDownloadFiles("",filePath);
        break;
      default:
        console.log('Unknown Path');
        break;
    }

  }

  onClickDownloadFiles(userCWSID?: string, fileName?: string) {
    this.isLoadingData = true;
    let downloadFileName = userCWSID !== "" ? fileName + "_" + userCWSID + "_QR_Images.zip" : fileName;
    let filePath = fileName;

    this.dataSourceService
      .downloadQRImages(userCWSID, filePath)
      .pipe(
        takeUntil(this.unsubscribe))
      .subscribe(
        (response) => {

          if (response.isValid && response.fileBytes) {
            const byteChar = atob(response.fileBytes);

            const byteNumbers = new Array(byteChar.length);

            for (let i = 0; i < byteChar.length; i++) {
              byteNumbers[i] = byteChar.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            const blob = new Blob([byteArray], { type: response.fileType });

            // const fileName = response.FileName.endsWith(".zip") ? response.FileName : response.FileName + ".zip";
            FileSaver.saveAs(blob, `${downloadFileName}`);
            this.isLoadingData = false;
          } else {
            this.downloadqrResponse = response;
            this.isLoadingData = false;
            console.log('Downloaded QR Images data is Invalid:');
          }
        },
        (error: any) => {
          console.log('Error Downloading QR Images:', error);
          this.isLoadingData = false;
        }
      );
  }

  onSearchInput(event: any) {
    this.showPartNumberError = false;
    this.downloadqrResponse = null;
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^a-zA-Z0-9\-]/g, '');
    this.searchQuery = input.value;
    if (this.searchQuery.length > this.maxChars) {
      this.searchQuery = this.searchQuery.substring(0, this.maxChars);
      this.showMaxLimitError = true;
      this.isDisableGenQR = true;
    } else if(this.searchQuery == '') {
      this.isDisableGenQR = true;
    } 
    else {
      this.showMaxLimitError = false;
      this.isDisableGenQR = false;
    }
  }


  onSearchAndDownloadQRClick() {
    const userInputPartNumber = this.searchQuery;
    const upperCasePartNumber = this.searchQuery.toUpperCase();

    if(this.isGeneratedQREnabled && this.partNumber === upperCasePartNumber && this.searchQuery !== '') {
      this.onClickDownloadFiles(this.user?.cwsId, userInputPartNumber);
      return;
    }
    if (this.searchQuery != '') {
      this.generateQRLink = '';
      this.isLoadingData = true;
      this.partNumber = upperCasePartNumber;
      this.dataSourceService
        .searchQRImages(this.partNumber)
        .pipe(
          takeUntil(this.unsubscribe))
        .subscribe({
          next: (searchResponse: boolean) => {
            this.isLoadingData = false;
            this.isDisableGenQR = !searchResponse;
            this.showPartNumberError = !searchResponse;
            this.isGeneratedQREnabled = searchResponse;
            if (searchResponse) {
              this.isLoadingData = true;
              this.dataSourceService
              this.onClickDownloadFiles(this.user?.cwsId, this.searchQuery);
            }
          },
          error: (error: any) => {
            console.log('Error Search QR Images:', error);
            this.isLoadingData = false;
            this.isDisableGenQR = true;
          }
        });
    }

  }

}
// if(response.IsValid && response.fileBytes) {
//             const byteChar = atob(response.fileBytes);

//             const byteNumbers = new Array(byteChar.length);
//             for(let i=0; i < byteChar.length; i++) {
//               byteNumbers[i] = byteChar.charCodeAt(i);
//             }
//             const byteArray = new Uint8Array(byteNumbers);
//             const data = new Blob([byteArray], { type: response.FileType});
//             this.isLoadingData = false;
//             FileSaver.saveAs(data, `${downloadFileName}`);
//           } else {
//             this.isLoadingData = false;
//             console.log('Downloaded QR Images data is Invalid:');
//           }